
import React from 'react';
import {TableProps,ColumnProps} from 'antd/lib/table';
import classnames from "classnames";
import {listItemType, User} from '@/types/OrderType'
import Table from '../Table'
import './style/OrderTable.less'
import StylesType from '@/types/StylesType'

export interface OrderTableTypes{
    columns: ColumnProps<User&listItemType>[]
}
export type OrderTableProps = StylesType & OrderTableTypes & TableProps<any>

const OrderTable: React.FC<OrderTableProps> = props => {
    const { dataSource, columns} = props

    return <Table rowKey='id' scroll={{y: 'calc(100vh - 250px)',x: '1200px'}} columns={columns} dataSource={dataSource} className={classnames('orderTable')} pagination={false} />

}

export default OrderTable;
